import React, { Component, Fragment } from 'react';
import { css, StyleSheet } from 'aphrodite';
import { CircularProgress, Container, Grid, IconButton, InputAdornment, Paper, TextField, Typography } from '@material-ui/core';
import { AppButton } from '../../common/components/AppButton';
import { Helper } from '../../common/helpers/Helper';
import { UiHelper } from '../../common/helpers/UiHelper';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { AppUiHelper } from '../../helpers/AppUiHelper';
import Tooltip from '@material-ui/core/Tooltip';
import { AppTheme } from '../../styles/AppTheme';
import { SingleSelectDropDown } from '../../common/components/SingleSelectDropDown';
export class CampaignMediaDNDItems extends Component {

  constructor(props) {
    super(props)
  }

  _listThumbnail = (item) => {
    if ((item.layoutjson && item.layoutjson.sections) || (item.mediaType &&  item.mediaType === 'LAYOUT') ) {
      return (<span  alt={Helper.getString('assetImageAlt')} className={css(Styles.layoutIcons)} >LAYOUT</span>)
    } else if (item.iType === 'VIDEO') {
      const props = {
        imageStyle: Styles.assetsImageContent,
        iconStyle: Styles.icons
      }
      return AppUiHelper.renderVideoThumbnailCustomStyle(item, props)
    } else if (item.iType === 'WEBLINK') {
      return (<i alt={Helper.getString('assetImageAlt')} className={'icons material-icons-outlined ' + css(Styles.icons)} >http</i>)
    } else if (item.iType === 'TEXT') {
      return (<span  alt={Helper.getString('assetImageAlt')} className={css(Styles.layoutIcons)} >TEXT</span>)
    } else if (item.iType === 'ACCUWEATHER') {
      return (<span  alt={Helper.getString('assetImageAlt')} className={css(Styles.layoutIcons)} >{Helper.getString('weather')}</span>)
    } else if (item.iType === 'HDMI-IN') {
      return (<span  alt={Helper.getString('assetImageAlt')} className={css(Styles.layoutIcons)} >HDMI-IN</span>)
    } else if (item.iType === 'CMS') {
      return (<span  alt={Helper.getString('assetImageAlt')} className={css(Styles.layoutIcons)} >CMS ONLY</span>)
    } else if (item.iType === 'PROG_AND_CMS') {
      return (<span  alt={Helper.getString('assetImageAlt')} className={css(Styles.layoutIcons)} >PROG-CMS</span>)
    } else {
      return (
        <img alt={Helper.getString('assetImageAlt')} src={item.content} className={css(Styles.assetsImageContent)} />
      )
    }
  }
  _getTypeIcon = (item) => {
    if (item.iType === 'IMAGE') {
      return (<img className={css(Styles.typeIconImage)} src={require('../../assets/icons/mediaDnd/image.svg')} />)
    } else if (item.iType === 'VIDEO') {
      return (<img className={css(Styles.typeIconImage)} src={require('../../assets/icons/mediaDnd/video.svg')} />)
    } else if (item.iType === 'WEBLINK') {
      return (<img className={css(Styles.typeIconImage)} src={require('../../assets/icons/mediaDnd/link.svg')} />)
    } else if (item.iType === 'LAYOUT') {
      return (<img className={css(Styles.typeIconImage)} src={require('../../assets/icons/mediaDnd/layout.svg')} />)
    } else if (item.iType === 'TEXT') {
      return (<img className={css(Styles.typeIconImage)} src={require('../../assets/icons/mediaDnd/text.svg')} />)
    } else if (item.iType === 'ACCUWEATHER') {
      return (<img className={css(Styles.typeIconImage)} src={require('../../assets/icons/mediaDnd/weather.svg')} />)
    } else if (item.iType === 'HDMI-IN') {
      return (<img className={css(Styles.typeIconImage)} src={require('../../assets/icons/mediaDnd/hdmiIn.svg')} />)
    } else {
      return (<img className={css(Styles.typeIconImage)} src={require('../../assets/icons/mediaDnd/image.svg')} />)
    }
  }

  _handleAddButton = (item) => {
    if(this.props.handleAddButton) this.props.handleAddButton(item)
  }

  _isSLMediaType = () => {
    return this.props.layout && this.props.layout.layoutType === 'SL' ? true : false
  }

  render() {
    return (
      <Fragment>
        <div className={css(Styles.container)}>
          <div className={css(Styles.headerContainer)}>
            <div className={css(Styles.title)}>{this._isSLMediaType() ? 'Sources' : 'Media'}</div>
            {!this._isSLMediaType() && this.props.mediaUploadHandle && (
              <AppButton
                onClick={this.props.mediaUploadHandle}
                buttonText={this.props.buttonText || Helper.getString('upload')}
              />
            )}
          </div>
          {!this._isSLMediaType() && this.props.handleSearchAction && (
            <div className={css(Styles.multiFilterBlock)}>
              <div className={css(Styles.inputAdornmentDorpDown)}>
                {/* Render your existing dropdown */}
                {this.props.singlePickerOptions && this.props.singlePickerHandler && this.props.singlePickerDefaultValue && (
                  <SingleSelectDropDown
                    onSinglePickerFilter={this.props.singlePickerHandler}
                    singleSelectPicker={{
                      options: this.props.singlePickerOptions,
                      defaultValue: this.props.singlePickerDefaultValue,
                    }}
                    className={css(Styles.dropdown)}
                    inputContainer={Styles.dropDownInputContainer}
                    textInputStyles={Styles.textInputStyles}
                  />
                )}
              </div>
              <TextField
                value={this.props.query || ''}
                variant='outlined'
                placeholder='Search keywords'
                fullWidth
                InputProps={{
                  classes: {
                    root: css(Styles.root),
                    notchedOutline: css(Styles.fieldSet),
                    input: css(Styles.textInput),
                  },
                  endAdornment: (
                    <div position='end' className={css(Styles.inputAdornment)}>
                      {this.props.inProcessSearch ? (
                        <IconButton className={css(Styles.searchButton)}>
                          <CircularProgress size={20} className={css(Styles.circularProgress)} />
                        </IconButton>
                      ) : (
                        <IconButton onClick={this.props.handleSearchAction} className={css(Styles.searchButton)}>
                          <img
                            width='20'
                            height='20'
                            src={require('../../assets/icons/search-white.svg')}
                            alt='Search'
                          />
                        </IconButton>
                      )}
                    </div>
                  ),
                }}
                className={css(Styles.searchField)}
                onKeyPress={(e) => { if (e.key === 'Enter') this.props.handleSearchAction(e) }}
                onChange={this.props.onChangeSearchValue}
              />
            </div>
          )}
          <div className={css(Styles.noteText)}>
            {Helper.getString('tipMediaDnd')}
          </div>


          <Droppable
            isDropDisabled={this.props.isDropDisabled}
            droppableId={this.props.droppableTableId || 'media-dnd-component'}
          >
            {(provided) => (
              <div className={`${css(Styles.mediaGrid)} mediaGrid`}>
                {this.props.mediaItems && this.props.mediaItems.length <= 0 &&
                  <div className={css(Styles.noteMediaText)}>
                    {Helper.getString('emptyMediaDnd')}
                  </div>
                }
                <Grid
                  container
                  spacing={0}
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {this.props.mediaItems.map((item, index) => (
                    <Draggable
                      isDragDisabled={!this.props.isDragEnabled}
                      key={item.id}
                      draggableId={String(item.id)}
                      index={index}
                    >
                      {(provided, snapshot) => (
                        <Fragment>
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={4}
                            lg={4}
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            className={snapshot.isDragging ? css([Styles.draggingRow]) : ''}
                          >
                            <div className={css(Styles.mediaItem)} elevation={2}>
                              <div className={css(Styles.thumbnailHolder)}>
                                {this.props.handleAddButton &&
                                  <img
                                    onClick={() => { this._handleAddButton({ item, index }) }}
                                    className={css(Styles.addButton)}
                                    src={require('../../assets/icons/add-square.svg')}
                                    alt='Add'
                                  />
                                }
                                {this._listThumbnail(item)}
                              </div>
                              {/* Title */}
                              <div className={css(Styles.itemTitle)}>
                                <Tooltip key={'tooltip-' + index} title={ `${item.iType} - ${item.title}`} placement='top-start'>
                                  <div className={css(Styles.itemTitleEllipsis)}>
                                    <span className={css(Styles.itemLinkIcon)}>
                                      {this._getTypeIcon(item)}
                                    </span>
                                    {item.title}
                                  </div>
                                </Tooltip>
                              </div>
                            </div>
                          </Grid>
                          {/* {snapshot.isDragging && this.props.draggingItem && (
                          )} */}
                        </Fragment>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </Grid>
              </div>
            )}
          </Droppable>
        </div>
      </Fragment>

    )
  }

}

const Styles = StyleSheet.create({
  multiFilterBlock:{
    margin: '22px 0px',
    display: 'flex',
    flexDirection: 'row',
    gap: 8
  },
  dropDownInputContainer:{
    background: 'none'
  },
  inputAdornmentDorpDown: {
    height: '100%',
    display: 'flex',
    flex:1,
    alignItems: 'center',
    // backgroundColor: AppTheme.buttonBg,
    // borderLeft: 'solid 1px rgba(191, 191, 191, 0.4 )'
    background: 'rgb(247, 247, 249)',
    borderRadius: 8
  },
  textInputStyles:{
    background: 'none',
    ':focus':{
      background: 'none'
    }
  },
  layoutIcons:{
    fontSize: '17px !important',
    fontWeight: 900,
    color: '#fff'
  },
  noteMediaText:{
    textAlign: 'center !important',
    // padding: '110px  0px 154px !important',
    fontSize: '20px',
    width: '100%',
    // marginTop: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    color: '#4a4a4a'
  },
  typeIconImage:{
    width: 12,
    height: 12
  },
  container: {
    padding: 28,
    background: '#ffffff',
    borderRadius: 16,
    // marginTop: '-110px'
    marginBottom: 20,
    // minHeight: 480
  },
  headerContainer: {
    display: 'flex !important',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  title: {
    marginBottom: 2,
    color: '#121212',
    fontSize: 28
  },
  uploadButton: {
    backgroundColor: '#3f51b5',
    color: '#fff',
    textTransform: 'none',
    marginBottom: 2,
  },
  root: {
    paddingRight: 0,
    overflow: 'hidden'
  },
  searchField: {
    background: '#F7F7F9',
    borderRadius: 8,
    overflow: 'hidden'
  },
  textInput: {
    fontSize: 14,
    border: 'none',
    height: 8,
    color: '#575757',
    overflow: 'hidden'
  },
  fieldSet: {
    border: 'none'
  },
  circularProgress: {
    // marginRight: '12px',
    color: '#FFFFFF'
  },
  noteText: {
    color: '#575757',
    fontSize: 13,
    margin: '16px 0px'
  },

  mediaGrid: {
    marginTop: 2,
    height: window.innerHeight - 420,
    overflowY: 'auto',
  },
  mediaItem: {
    textAlign: 'center',
    margin: '0 auto',
    padding: 6
  },
  addButton: {
    position: 'absolute',
    right: 8,
    top: 8,
    cursor: 'pointer'
  },
  itemTitle: {
    color: '#121212',
    width: '100%',
    fontSize: 12,
    marginTop: 2,
    textAlign: 'left'
  },
  itemTitleEllipsis:{
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  itemLinkIcon: {
    padding: 2,
    float: 'left'
  },
  icons: {
    color: '#ffffff',
    fontSize: 55,
  },
  thumbnailHolder:{
    width: '100%',
    aspectRatio: '1/1',
    background: '#e4e4e4',
    borderRadius: 8,
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  assetsImageContent: {
    borderRadius: 8,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    // marginLeft: 1
    border: 'solid 1px whitesmoke !important'
  },
  searchButton: {
    borderRadius: 0,
    // backgroundColor: AppTheme.buttonBg,
    minHeight: '100%',
    margin: 0
  },
  inputAdornment: {
    height: '100%',
    display: 'flex',
    flex:1,
    alignItems: 'center',
    backgroundColor: AppTheme.buttonBg,
  },
})


// WEBPACK FOOTER //
// ./src/screens/admin/CampaignMediaDNDItems.js